import React, { useState } from 'react';
import { Button, Modal, Form, Spinner, Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { DraggableModalDialog } from '../Dialogs/DraggableModalDialog';
import CommentDialog from '../Dialogs/CommentDialog';
import { useHttpUtils } from '../Utilities/useHttpUtils';
import useAlert from '../Alerts/useAlert';
import { DialogSelect } from '../DialogInputs';

function RegradeDialog({ showDialog, closeDialog, lotNumber, getLotDetail, alternativeGrades, grades, loading }) {

    const { t } = useTranslation();
    const { fetchDataAuthenticated } = useHttpUtils();

    const [selectedGrade, setSelectedGrade] = useState(null);
    const [selectedOther, setSelectedOther] = useState(false);
    const [formValidated, setFormValidated] = useState(false);
    const [showCommentDialog, setShowCommentDialog] = useState(false);
    const { setAlert } = useAlert();

    const handleSelectGrade = (e) => {

        if (e.target.dataset.id !== "other") {
            setSelectedOther(false);
            setSelectedGrade(e.target.dataset.id);
        } else {
            setSelectedOther(true);
        }
    };

    const handleSave = (e) => {
        e.preventDefault();
        e.stopPropagation();

        const form = e.currentTarget;

        if (form.checkValidity() === true) {
            setShowCommentDialog(true);
        } else {
            console.warn("Change lot grade form was invalid");
        }

        setFormValidated(true);
    };

    const regradeLotWithComment = async (comment) => {

        let body = {
            grade: selectedGrade,
            comment: comment
        };

        fetchDataAuthenticated(`api/v1/lot/grade/${lotNumber}`, "PUT", JSON.stringify(body))
            .then(response => {
                if (response.ok) {
                    setAlert("success", "Success", "Lot was regraded successfully. Package type set to default package type for this grade.");
                    getLotDetail();
                    closeDialogAndResetForm();
                } else {
                    throw new Error("Failed to regrade lot.");
                }
            })
            .catch(error => {
                setAlert("danger", "Error", error.message);
            });
    };

    const closeDialogAndResetForm = () => {
        setFormValidated(false);
        closeDialog();
    };

    return (
        <>
            <Modal dialogAs={DraggableModalDialog} show={showDialog} onHide={closeDialogAndResetForm} backdrop="static">
                <Modal.Header closeButton>
                    {loading &&
                        <Modal.Title>{t("Dialogs.Regrade.LoadingGradesMessage")}</Modal.Title>
                    }
                    {!loading &&
                        <Modal.Title>{t("Dialogs.Regrade.SelectGradeMessage")}</Modal.Title>
                    }
                </Modal.Header>
                <Modal.Body>
                    {loading &&
                        <div className="d-flex justify-content-center">
                            <Spinner animation="border" />
                        </div>
                    }
                    {!loading &&
                        <Form id="regradeLot" noValidate validated={formValidated} onSubmit={handleSave}>
                            <Form.Group controlId="gradeSelection">
                                <Form.Group as={Row} controlId="alternativeGradeSelection" className="mb-3">
                                    <Form.Label column xs={4}>{t("Dialogs.Regrade.AlternativeGrades")}</Form.Label>
                                    <Col xs={8} className="pt-2">
                                        {
                                            alternativeGrades.map((grade, index) => {
                                                return (
                                                    <Form.Check
                                                        type="radio"
                                                        name="grades"
                                                        key={index}
                                                        id={`grade-${grade}`}
                                                        data-id={grade}
                                                        label={grade}
                                                        className="form-radio-input ms-2 mb-3"
                                                        onChange={handleSelectGrade}
                                                        required
                                                    />
                                                );
                                            })
                                        }
                                        <Form.Check
                                            type="radio"
                                            key={999}
                                            name="grades"
                                            id="grade-other"
                                            data-id="other"
                                            label={t("Dialogs.Regrade.Other")}
                                            className="form-radio-input ms-2 mb-3"
                                            onChange={handleSelectGrade}
                                            required
                                        />
                                    </Col>
                                </Form.Group>
                                {selectedOther &&
                                    <DialogSelect controlId="selectOtherGrade" title={t("Dialogs.Regrade.OtherGrades")} onChange={(e) => setSelectedGrade(e.target.value)}>
                                        <option>{t("Dialogs.Regrade.SelectGrade")}</option>
                                        {
                                            grades.map((grade) => {
                                                return <option value={grade}>{grade}</option>;
                                            })
                                        }
                                    </DialogSelect>
                                }
                            </Form.Group>
                        </Form>
                    }
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={closeDialogAndResetForm}>
                        {t("Application.Controls.Close")}
                    </Button>
                    <Button variant="primary" type="submit" form="regradeLot" disabled={selectedGrade === null}>
                        {t("Dialogs.Regrade.Regrade")}
                    </Button>
                </Modal.Footer>
            </Modal>
            <CommentDialog showDialog={showCommentDialog} closeDialog={() => setShowCommentDialog(false)} onSave={regradeLotWithComment} />
        </>
    );
}

export default RegradeDialog;